// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2L9_h","col":"styles_col__2ftRd"};